import React, { useEffect } from 'react';
import { Table, Tooltip } from 'antd';
import MeetingStatus from 'modules/dashboard/search/MeetingStatus';
import _ from 'lodash';
import Detail from 'modules/dashboard/search/Detail';
import Request from 'common/network/Request';
import dashboardApis from 'modules/dashboard/api';
import {
  IoAlertCircleOutline,
  IoBowlingBallOutline,
  IoCheckmarkCircle,
  IoHeart,
  IoHeartOutline,
} from 'react-icons/io5';
import dayjs from 'dayjs';
import { useMediaQuery } from 'react-responsive';
import clsx from 'clsx';

const Results = ({ results, loading, onChangePagination, refetch }) => {
  const isSmallScreen = useMediaQuery({ maxWidth: 768 });
  const [buttonLoadings, setButtonLoadings] = React.useState({});
  const [favoriteIds, setFavoriteIds] = React.useState({});
  const [numberOfMeetings, setNumberOfMeetings] = React.useState({});

  const dataSource = _.get(results, 'data', []);

  useEffect(() => {
    if (!_.isEmpty(dataSource)) {
      const numbers = _.reduce(
        dataSource,
        (acc, item) => {
          acc[item.id] = _.get(item.meeting_histories, 'length', 0);
          return acc;
        },
        {},
      );

      setNumberOfMeetings(numbers);
    }
  }, [dataSource]);

  const handleClickFavorite = async (item) => {
    const { id } = item;
    setButtonLoadings((prev) => ({
      ...prev,
      [id]: true,
    }));
    try {
      const response = await Request.post(dashboardApis.toggle_favorite, {
        id,
      });

      setFavoriteIds((prev) => ({
        ...prev,
        [id]: response?.result,
      }));
    } catch (error) {}
    setButtonLoadings((prev) => ({
      ...prev,
      [id]: false,
    }));
  };

  const columns = [
    {
      title: 'Ứng viên',
      dataIndex: 'name',
      render(name, row) {
        const { id } = row;
        const isFavorite = favoriteIds[id] ?? row.is_favorite;
        const isLoading = buttonLoadings[id];
        const IconComp = isLoading
          ? IoBowlingBallOutline
          : isFavorite
            ? IoHeart
            : IoHeartOutline;

        return (
          <div>
            <div className="flex justify-between items-center gap-3 md:px-4">
              <span>{name}</span>
              <span
                onClick={() => {
                  if (isLoading) return;
                  handleClickFavorite(row);
                }}
              >
                <IconComp
                  size="1.5em"
                  color="#E62000"
                  className={clsx({
                    'animate-spin': isLoading,
                    'cursor-wait': isLoading,
                    'cursor-pointer': !isLoading,
                  })}
                />
              </span>
            </div>
            <div className="mt-2 block md:hidden">
              <MeetingStatus item={row} value={numberOfMeetings[row.id]} />
            </div>
          </div>
        );
      },
      width: isSmallScreen ? '50%' : '30%',
    },
    {
      title: 'Ngày update',
      dataIndex: 'updated_at',
      width: isSmallScreen ? '30%' : '20%',
      render: (date) => (
        <Tooltip title={dayjs(date).format('DD/MM/YYYY')}>
          {dayjs(date).format('DD/MM')}
        </Tooltip>
      ),
    },
    {
      title: 'Tình trạng',
      width: '30%',
      render: (val, row) => {
        return <MeetingStatus item={row} value={numberOfMeetings[row.id]} />;
      },
      responsive: ['md'],
    },
    {
      title: 'Xác nhận',
      dataIndex: 'ad_confirmed',
      width: '20%',
      render: (adConfirm) => {
        return (
          <div className="flex justify-center items-center">
            {adConfirm ? (
              <IoCheckmarkCircle color="#10b981" size="1.5em" />
            ) : (
              <IoAlertCircleOutline color="#fbbf24" size="1.5em" />
            )}
          </div>
        );
      },
      align: 'center',
    },
  ];

  const onFetchMeetingSuccess = (record, meetings) => {
    setNumberOfMeetings((prev) => ({
      ...prev,
      [record.id]: _.get(meetings, 'length', 0),
    }));
  };

  return (
    <Table
      bordered
      dataSource={dataSource}
      columns={columns}
      rowKey={(record, index) => {
        return record.id + record.updated_at + index;
      }}
      scroll={{ x: true }}
      size={
        //small on mobile device
        isSmallScreen ? 'small' : 'large'
      }
      pagination={{
        hideOnSinglePage: true,
        onChange: (page, pageSize) => {
          if (typeof onChangePagination === 'function') {
            onChangePagination((prev) => ({
              ...prev,
              page,
              per_page: pageSize,
            }));
          }
        },
        total: _.get(results, 'total', 0),
      }}
      loading={loading}
      expandable={{
        childrenColumnName: 'meeting_histories',
        expandedRowRender: (record) => (
          <Detail
            record={record}
            onFetchMeetingSuccess={(meetings) =>
              onFetchMeetingSuccess(record, meetings)
            }
            refetch={refetch}
          />
        ),
      }}
      className="[&_.ant-table-row-expand-icon]:text-primary [&_.ant-table-row-expand-icon]:border-primary"
    />
  );
};

export default Results;
